module.exports = __webpack_public_path__ + "static/media/chartstesthoriz.e186d292.png";